import { fetchEstats, fetchFluxoCaixa, fetchIFsCaixa, changePassword, fetchResumoCart, fetchResumoCartPerf, fetchPerfHist, fetchPerfHistPerf, fetchModalPosCon, fetchPosCon, fetchCarteiraList, fetchPreference, fetchPreferenceWhitelabel, fetchFluxoAtivos, fetchCapaPdf, } from './../api';
import { createSlice } from '@reduxjs/toolkit';
import { checkPeriodoPersonalizado, compareDatesDDMMYYYY, changeTimezone } from '@monorepo-web/utils';
import { fetchFulfilledStateBuilder, fetchRejectedStateBuilder } from './helperFetchReducer';
const initialState = {
    loading: false,
    loadingCarteiraList: false,
    loadedCarteiraList: false,
    loadingTrocarSenha: false,
    isLoadedPreferenceStyle: false,
    trocarSenhaStatus: 'none',
    loginError: false,
    unauthorized: false,
    recalcular: false,
    token: {
        value: null,
        expiration: null,
    },
    usuario: '',
    id: null,
    carteiraList: [],
    flagTrocaSenha: '',
    dateStart: '',
    dateEnd: '',
    params: {
        carteira: null,
        periodo: '',
    },
    loggedIn: false,
    preferenceStyle: {
        estilo: null,
        login: null,
        imagem: null,
        imagemAPI: null,
        customizacao: null,
        liberacao: null,
        layoutPDF: null,
    },
    modalDisclaimerActive: true,
};
export const preferenceSlice = createSlice({
    name: 'preference',
    initialState,
    reducers: {
        setLoggedIn: (state, action) => {
            state.loggedIn = action.payload;
        },
        setToken: (state, action) => {
            var _a, _b;
            state.token.value = (_a = action.payload.token) !== null && _a !== void 0 ? _a : null;
            state.token.expiration = (_b = action.payload.expiration) !== null && _b !== void 0 ? _b : null;
        },
        setStatusSenha: (state, action) => {
            state.trocarSenhaStatus = action.payload;
        },
        resetParams: (state) => {
            // mantém o atributo preferenceStyle.login, porque não deve resetar o estilo da página de login quando o usuário deslogar
            const newState = Object.assign(Object.assign({}, initialState), { preferenceStyle: Object.assign(Object.assign({}, initialState.preferenceStyle), { login: state.preferenceStyle.login }) });
            return newState;
        },
        setCarteiraID: (state, action) => {
            state.params.carteira = action.payload;
        },
        toggleRecalcular: (state) => {
            state.recalcular = !state.recalcular;
        },
        setRecalcular: (state, action) => {
            state.recalcular = action.payload;
        },
        resetStateHelper: (state) => {
            state.loadedCarteiraList = false; // recarregar a CarteiraList ao recalcular
            return state;
        },
        setParams: (state, action) => {
            var _a;
            for (const prop in state.params) {
                if (Object.hasOwnProperty.call(state.params, prop) &&
                    Object.hasOwnProperty.call(action.payload, prop) &&
                    action.payload[prop]) {
                    state.params[prop] = action.payload[prop];
                }
            }
            const matches = checkPeriodoPersonalizado((_a = state.params.periodo) !== null && _a !== void 0 ? _a : '');
            if (matches) {
                state.dateStart = matches.start;
                state.dateEnd = matches.end;
            }
        },
        setDataPersonalizada: (state, action) => {
            state.dateStart = action.payload.dataIni;
            state.dateEnd = action.payload.dataFim;
            state.params.periodo = `${action.payload.dataIni}%20${action.payload.dataFim}`;
        },
        setData: (state, action) => {
            state.params.periodo = action.payload;
        },
        setDataFim: (state, action) => {
            var _a;
            const matches = checkPeriodoPersonalizado((_a = state.params.periodo) !== null && _a !== void 0 ? _a : '');
            if (matches) {
                const startDate = /^\d+$/.test(matches.start) && compareDatesDDMMYYYY(matches.start, action.payload) >= 0
                    ? 'maximo'
                    : matches.start;
                state.params.periodo = `${startDate}%20${action.payload}`;
            }
            else {
                state.params.periodo = `${state.params.periodo}%20${action.payload}`;
            }
        },
        setPreferenceStyle: (state, action) => {
            var _a;
            state.preferenceStyle = action.payload;
            if ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.estilo) {
                // se tiver campo estilo, está carregado
                state.isLoadedPreferenceStyle = true;
            }
        },
        setModalDisclaimerActive: (state, action) => {
            state.modalDisclaimerActive = action.payload;
            window.sessionStorage.setItem('disclaimer', JSON.stringify(action.payload)); // guarda no session do navegador, para manter estado ao recarregar pgina
        },
    },
    extraReducers: (builder) => {
        // change password cases
        builder.addCase(changePassword.fulfilled, (state) => {
            state.loadingTrocarSenha = false;
            state.trocarSenhaStatus = 'ok';
        });
        builder.addCase(changePassword.pending, (state) => {
            state.loadingTrocarSenha = true;
        });
        builder.addCase(changePassword.rejected, (state, action) => {
            state.loadingTrocarSenha = false;
            const payload = action.payload;
            if (payload.errors[0] && payload.errors[0].codigo === '1b6321') {
                state.trocarSenhaStatus = 'error';
            }
        });
        // login cases
        builder.addCase(fetchPreference.pending, (state) => {
            state.loading = true;
            state.loginError = false;
        });
        builder.addCase(fetchPreference.fulfilled, (state, action) => {
            var _a, _b, _c, _d, _e, _f;
            state.loading = false;
            state.flagTrocaSenha = (_b = (_a = action.payload.usuario_final) === null || _a === void 0 ? void 0 : _a.recadastrar_senha_proximo_acesso) !== null && _b !== void 0 ? _b : [];
            if ((_c = action.payload.usuario_final) === null || _c === void 0 ? void 0 : _c.recadastrar_senha_proximo_acesso)
                localStorage.setItem('flagTrocaSenha', (_d = action.payload.usuario_final) === null || _d === void 0 ? void 0 : _d.recadastrar_senha_proximo_acesso);
            if (action.payload.access_token) {
                state.token.value = action.payload.access_token;
                state.token.expiration = action.payload.expires_in
                    ? changeTimezone(new Date(action.payload.expires_in), 'America/Sao_paulo').getTime()
                    : null;
                window.localStorage.setItem(`token-${(_f = (_e = window.env) === null || _e === void 0 ? void 0 : _e.REACT_APP_NAME) !== null && _f !== void 0 ? _f : 'comdinheiro'}`, JSON.stringify(Object.assign({}, state.token)));
            }
            if (action.payload.preference_whitelabel) {
                state.preferenceStyle = Object.assign(Object.assign({}, state.preferenceStyle), action.payload.preference_whitelabel);
                state.isLoadedPreferenceStyle = true;
            }
        });
        builder.addCase(fetchPreference.rejected, (state) => {
            state.loading = false;
            state.loginError = true;
        });
        // list portfolio cases
        builder.addCase(fetchCarteiraList.pending, (state) => {
            state.loadingCarteiraList = true;
        });
        builder.addCase(fetchCarteiraList.fulfilled, (state, action) => {
            var _a, _b, _c;
            state.loadedCarteiraList = true;
            state.loadingCarteiraList = false;
            state.carteiraList = (_a = action.payload.ListaCarteiras) !== null && _a !== void 0 ? _a : [];
            if (action.payload.access_token && action.payload.expires_in) {
                state.token.value = action.payload.access_token;
                state.token.expiration = action.payload.expires_in * 1000;
                window.localStorage.setItem(`token-${(_c = (_b = window.env) === null || _b === void 0 ? void 0 : _b.REACT_APP_NAME) !== null && _c !== void 0 ? _c : 'comdinheiro'}`, JSON.stringify(Object.assign({}, state.token)));
            }
        });
        builder.addCase(fetchPreferenceWhitelabel.fulfilled, (state, action) => {
            if (action.payload.response) {
                state.preferenceStyle = Object.assign(Object.assign({}, state.preferenceStyle), action.payload.response);
                state.isLoadedPreferenceStyle = true;
            }
        });
        // expired token cases for each API call
        fetchRejectedStateBuilder(builder, fetchResumoCart);
        fetchRejectedStateBuilder(builder, fetchResumoCartPerf);
        fetchRejectedStateBuilder(builder, fetchCarteiraList);
        fetchRejectedStateBuilder(builder, fetchPreferenceWhitelabel);
        fetchRejectedStateBuilder(builder, fetchPerfHist);
        fetchRejectedStateBuilder(builder, fetchPerfHistPerf);
        fetchRejectedStateBuilder(builder, fetchPosCon);
        fetchRejectedStateBuilder(builder, fetchModalPosCon);
        fetchRejectedStateBuilder(builder, fetchFluxoAtivos);
        fetchRejectedStateBuilder(builder, fetchFluxoCaixa);
        fetchRejectedStateBuilder(builder, fetchIFsCaixa);
        fetchRejectedStateBuilder(builder, fetchEstats);
        fetchRejectedStateBuilder(builder, fetchCapaPdf);
        // set new token and date cases for each API call
        fetchFulfilledStateBuilder(builder, fetchResumoCart, 'ResumoCart');
        fetchFulfilledStateBuilder(builder, fetchResumoCartPerf, '');
        fetchFulfilledStateBuilder(builder, fetchPerfHist, 'PerfHist');
        fetchFulfilledStateBuilder(builder, fetchPerfHistPerf, '');
        fetchFulfilledStateBuilder(builder, fetchPosCon, 'PosCon');
        fetchFulfilledStateBuilder(builder, fetchModalPosCon, '');
        fetchFulfilledStateBuilder(builder, fetchFluxoAtivos, 'FluxoAtivos');
        fetchFulfilledStateBuilder(builder, fetchFluxoCaixa, 'FluxoCaixa');
        fetchFulfilledStateBuilder(builder, fetchIFsCaixa, 'IFsCaixa');
        fetchFulfilledStateBuilder(builder, fetchEstats, 'EstatAvanc');
        fetchFulfilledStateBuilder(builder, fetchCapaPdf, 'CapaPDF');
    },
});
export const { setLoggedIn, setToken, setStatusSenha, resetParams, setDataPersonalizada, setData, setDataFim, setParams, setCarteiraID, setModalDisclaimerActive, toggleRecalcular, setRecalcular, resetStateHelper, setPreferenceStyle, } = preferenceSlice.actions;
export default preferenceSlice.reducer;
